import React from 'react'
import { Box, Drawer, Typography } from '@mui/material';
import List from '@mui/material/List';
import SidebarButton from './SidebarButton';

import {
  BoltOutlined
} from '@mui/icons-material';

const DashboardSidebar = ({ width, navItems, activeTab, onItemClick }) => {

  // Group items by their section, keeping the original order
  const sections = [];
  navItems.forEach((navItem) => {
    const name = navItem.section ?? "";
    let section = sections.find(s => s.name === name);
    if (!section) {
      section = { name, items: [] };
      sections.push(section);
    }
    section.items.push(navItem);
  });

  return (
    <Drawer
      anchor="left"
      open={true}
      variant="persistent"
      PaperProps={{
        sx: {
          width: `${width}px`,
          position: 'absolute',
          height: '100%',
          boxSizing: 'border-box',
          px: 1.5,
          borderRight: "1px solid var(--c-border)",
          backgroundColor: "var(--c-surface)",
        }
      }}
    >
      {/* Brand */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        height: 64,
        px: 1,
        gap: 1.5,
      }}>
        <Box sx={{
          width: 36,
          height: 36,
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          background: "linear-gradient(135deg, #3B9BFF 0%, #137FEC 55%, #142784 100%)",
          boxShadow: "0 4px 12px rgba(19, 127, 236, 0.3)",
        }}>
          <BoltOutlined sx={{ color: "white", fontSize: 22 }} />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{
            fontSize: 16,
            fontWeight: 700,
            color: "var(--c-text)",
            lineHeight: 1.2,
            letterSpacing: "-0.01em",
          }}>
            POSH Energy
          </Typography>
          <Typography sx={{
            fontSize: 11,
            fontWeight: 500,
            color: "var(--c-text-faint)",
            lineHeight: 1.4,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}>
            Admin console
          </Typography>
        </Box>
      </Box>

      {/* Navigation */}
      <Box component="nav" aria-label="Dashboard" sx={{ pt: 1, pb: 2 }}>
        {sections.map((section) => (
          <Box key={section.name} sx={{ mb: 1.5 }}>
            {section.name && (
              <Typography sx={{
                px: 1.5,
                pt: 1,
                pb: 0.75,
                fontSize: 11,
                fontWeight: 600,
                color: "var(--c-text-faint)",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}>
                {section.name}
              </Typography>
            )}
            <List disablePadding>
              {section.items.map((navItem) => (
                <SidebarButton
                  key={navItem.title}
                  icon={navItem.icon}
                  text={navItem.title}
                  active={navItem.title === activeTab.title}
                  onClick={() => {
                    onItemClick(navItem)
                  }}
                />
              ))}
            </List>
          </Box>
        ))}
      </Box>
    </Drawer>
  )
}

export default DashboardSidebar;
